import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import { siteConfig } from '../data/mock';

const Contact = () => {
  return (
    <section
      id="contact"
      className="section-padding relative overflow-hidden grid-pattern grid-pattern-light"
      style={{ backgroundColor: '#F4F1E9' }}
    >
      {/* Decorative background */}
      <div
        className="absolute top-0 left-0 w-full h-full"
        style={{
          background: 'radial-gradient(ellipse at 20% 80%, rgba(214, 169, 79, 0.12) 0%, transparent 50%)'
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Contact Info */}
          <div>
            <span className="inline-block font-semibold text-xs tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full" style={{ color: '#D6A94F', backgroundColor: 'rgba(214, 169, 79, 0.08)', border: '1px solid rgba(214, 169, 79, 0.15)' }}>
              Get In Touch
            </span>
            <h2 className="font-display font-bold text-4xl sm:text-5xl mb-6" style={{ color: '#1F3B60' }}>
              Contact Us
            </h2>
            <div className="divider-gold mb-8" />

            <p className="text-lg mb-10" style={{ color: '#3A5A85' }}>
              Ready to discuss your property goals? Reach out to us today.
            </p>

            {/* Contact details */}
            <div className="space-y-6">
              <a
                href={`tel:${siteConfig.phone.replace(/[^0-9]/g, '')}`}
                className="flex items-center space-x-4 group"
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(135deg, #D6A94F, #E4C078)' }}>
                  <Phone className="w-6 h-6" style={{ color: '#1F3B60' }} />
                </div>
                <div>
                  <span className="block text-sm text-gray-500 mb-1">Phone</span>
                  <span className="text-lg font-semibold" style={{ color: '#1F3B60' }}>
                    {siteConfig.phone}
                  </span>
                </div>
              </a>

              <a
                href={`mailto:${siteConfig.email}`}
                className="flex items-center space-x-4 group"
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(135deg, #D6A94F, #E4C078)' }}>
                  <Mail className="w-6 h-6" style={{ color: '#1F3B60' }} />
                </div>
                <div>
                  <span className="block text-sm text-gray-500 mb-1">Email</span>
                  <span className="text-lg font-semibold" style={{ color: '#1F3B60' }}>
                    {siteConfig.email}
                  </span>
                </div>
              </a>

              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0" style={{ background: 'linear-gradient(135deg, #D6A94F, #E4C078)' }}>
                  <MapPin className="w-6 h-6" style={{ color: '#1F3B60' }} />
                </div>
                <div>
                  <span className="block text-sm text-gray-500 mb-1">Location</span>
                  <span className="text-lg font-semibold block" style={{ color: '#1F3B60' }}>
                    {siteConfig.address.street}
                  </span>
                  <span className="text-gray-600">
                    {siteConfig.address.city}, {siteConfig.address.state} {siteConfig.address.zip}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Card */}
          <div className="flex items-center">
            <div
              className="w-full p-8 lg:p-10 rounded-3xl relative overflow-hidden"
              style={{ backgroundColor: '#1F3B60' }}
            >
              {/* Background glow */}
              <div
                className="absolute top-0 right-0 w-64 h-64 rounded-full blur-3xl"
                style={{ background: 'rgba(214, 169, 79, 0.15)' }}
              />

              <div className="relative z-10">
                <h3 className="font-display font-bold text-2xl sm:text-3xl text-white mb-4">
                  Ready to Get Started?
                </h3>
                <p className="text-white/70 mb-8 leading-relaxed">
                  Whether you&apos;re looking to sell your property quickly or explore renovation options, we&apos;re here to help you make the right decision.
                </p>

                <div className="space-y-4">
                  <Link
                    to={siteConfig.links.offers}
                    className="btn-gold w-full flex items-center justify-center space-x-2 group"
                  >
                    <span>Get Your Offer</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                  <Link
                    to={siteConfig.links.renovations}
                    className="btn-outline-gold w-full flex items-center justify-center space-x-2 group"
                  >
                    <span>Request Renovation Quote</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
